import { useState } from "react";
import { useLang, ui, tx } from "../i18n";
import { Icon } from "./Icon";

const CONTACTS = [
  { id: "fab-911", label: "911", sub: { es: "Emergencias", en: "Emergencies" }, tel: "911", style: "bg-red-600 text-white" },
  { id: "fab-nmead", label: "NMEAD", sub: { es: "Manejo de Emergencias", en: "Emergency Management" }, tel: "7877240124", style: "bg-[#1C2B4A] text-white" },
  { id: "fab-pas", label: "Línea PAS", sub: { es: "Apoyo emocional 24/7", en: "Emotional support 24/7" }, tel: "18009810023", style: "bg-green-700 text-white" },
];

export function EmergencyFab() {
  const { lang } = useLang();
  const [open, setOpen] = useState(false);
  return (
    <div className="no-print md:hidden fixed bottom-5 right-4 z-50 flex flex-col items-end gap-2.5">
      {open && (
        <div data-testid="fab-panel" className="flex flex-col gap-2 rounded-xl border border-slate-300 bg-white/95 backdrop-blur-xl p-2.5 shadow-xl">
          <p className="px-2 pt-1 font-mono-pr text-[10px] font-bold uppercase tracking-[0.2em] text-slate-500">
            {tx(ui.fab.label, lang)}
          </p>
          {CONTACTS.map((c) => (
            <a
              key={c.id}
              data-testid={c.id}
              href={`tel:${c.tel}`}
              className={`flex items-center gap-3 rounded-lg px-4 py-3 font-bold text-sm ${c.style} active:scale-[0.98] transition-transform duration-150`}
            >
              <Icon name="Phone" className="w-4 h-4" />
              <span>
                {c.label}
                <span className="block text-[11px] font-medium opacity-80">{tx(c.sub, lang)}</span>
              </span>
            </a>
          ))}
        </div>
      )}
      <button
        data-testid="emergency-fab"
        onClick={() => setOpen((o) => !o)}
        aria-expanded={open}
        aria-label={tx(ui.fab.label, lang)}
        className="flex items-center justify-center w-14 h-14 rounded-full bg-amber-600 text-white shadow-lg shadow-amber-900/30 border-2 border-white active:scale-95 transition-transform duration-150"
      >
        <Icon name={open ? "ChevronRight" : "Phone"} className={`w-6 h-6 ${open ? "rotate-90" : ""}`} />
      </button>
    </div>
  );
}
